module.exports = __webpack_public_path__ + "static/media/post-icn.81f299aa.svg";